import { render, staticRenderFns } from "./peaStatusHistory.vue?vue&type=template&id=672be257&scoped=true"
import script from "./peaStatusHistory.vue?vue&type=script&lang=js"
export * from "./peaStatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672be257",
  null
  
)

export default component.exports